{
    "Accessibility menu": "Мени приступачности",
    "Close": "Затвори",
    "Content adjustments": "Прилагођавања садржаја",
    "Navigation adjustments": "Прилагођавања навигације",
    "Text Align": "Text Align",
    "Align Left": "Поравнај лево",
    "Align Center": "Align Center",
    "Align Right": "Align Right",
    "Adjust Font Size": "Подеси величину фонта",
    "Highlight Title": "Истакни наслов",
    "Highlight Links": "Истакни линкове",
    "Readable Font": "Читљив фонт",
    "Colour adjustments": "Прилагођавања боја",
    "Dark Contrast": "Тамни контраст",
    "Light Contrast": "Светли контраст",
    "High Contrast": "Високи контраст",
    "High Saturation": "Висока засићеност",
    "Low Saturation": "Ниска засићеност",
    "Monochrome": "Монохроматски",
    "Tools": "Алати",
    "Reading Guide": "Водич за читање",
    "Big Cursor": "Велики курсор",
    "Increase Font Size": "Повећај величину фонта",
    "Decrease Font Size": "Смањи величину фонта",
    "Letter Spacing": "Размак између слова",
    "Line Height": "Висина линије",
    "Font Weight": "Дебљина фонта",
    "Dyslexia Font": "Фонт за дислексију",
    "Language": "Језик",
    "Accessibility widget": "Отвори мени приступачности",
    "Accessibility Profiles": "Профили приступачности",
    "Cognitive Disability": "Когнитивна инвалидност",
    "Seizure Safe": "Безбедно за нападе",
    "Accessibility statement": "Изјава о приступачности",
    "ADHD": "ADHD",
    "Low Vision": "Low Vision",
    "Pause Animations": "Заустави анимације",
    "Animation paused": "Анимација је паузирана",
    "Reset all settings": "Ресетуј подешавања",
    "Shortcut:": "Shortcut:",
    "Epilepsy Safe Mode": "Epilepsy Safe Mode",
    "Mute sounds": "Mute sounds",
    "Page read": "Page read",
    "Page read controls": "Page read controls",
    "Pause": "Pause",
    "Resume": "Resume",
    "Stop": "Stop",
    "Settings": "Settings",
    "Speed": "Speed",
    "Voice": "Voice"
}
